// import { useState, useEffect } from "react";
import BackButton from "./BackButton";

const NotFound = () => {
  return (
    <>
      <h1>404 Page not found</h1>
      <BackButton />
    </>
  );
};

export default NotFound;
